import React from "react";
import { useHistory } from "react-router-dom";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

import LayerFunctional from "../../../LayerFunctional";
import CardAdminWidgetList from "../../../Component/Card/Admin/Widget/CardAdminWidgetList";
import PageHeader from "../../../Component/PageHeader";

export default function AdminWidgetList() {
    const history = useHistory();

    return (
        <LayerFunctional
            getMaxWidth={() => 1000}
            renderHeader={() => {
                const buttons = [
                    (
                        <MUIButton
                            key="create"
                            variant="contained"
                            startIcon={<MUIAddIcon />}
                            onClick={() => history.push("/admin/widget")}
                        >
                            Create New
                        </MUIButton>
                    ),
                ];

                return <PageHeader title="Widgets" buttons={buttons} />;
            }}
            renderContent={() => <CardAdminWidgetList />}
        />
    );
}
